@if (showBanner$ | async) {
    <div class="banner-env-container">
        <div class="banner-env" [ngClass]="{ bounce: showBounce }">
            <div>{{ "ENVIRONMENT.YOU_ARE_IN" | translate: { env: envName } }}</div>
        </div>
    </div>
}
